import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdsCampaign } from 'src/app/classes/ads-campaign';
import { AdsCampaignService } from 'src/app/services/ads-campaign.service';
import AdsCampaignStatuses from 'src/app/constants/ads-campaign-statuses';
import AdsCampaignTypes from 'src/app/constants/ads-campaign-types';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})

export class SearchComponent implements OnInit {
  adsCampaigns: AdsCampaign[] = [];

  adsCampaignStatuses = AdsCampaignStatuses;
  adsCampaignTypes = AdsCampaignTypes;

  constructor(
    private adsCampaignService: AdsCampaignService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.adsCampaignService.search(params).subscribe(adsCampaigns => {
        this.adsCampaigns = adsCampaigns;
      });
    });
  }

  delete(id: number) {
    if(confirm($localize`Are you sure?`)) {
      this.adsCampaignService.delete(id).subscribe(() => {
        this.adsCampaignService.search(this.route.snapshot.queryParams).subscribe(adsCampaigns => {
          this.adsCampaigns = adsCampaigns;
        });
      });
    }
  }
}
